<div class="custom-select">
  <select
    (ngModelChange)="onChangeActiveSortField()"
    [(ngModel)]="activeSortFieldKeyAndOrder"
    id="sort-on"
    >
    @for (sortField of sortFields; track sortField) {
      <option
      [innerHTML]="
        sortField.sortIconHtml
          ? sortField.name + ' ' + sortField.sortIconHtml
          : sortField.name
      "
        [value]="sortField.optionKey"
      ></option>
    }
  </select>
</div>
